export const companyData = {
  name: 'VeeraWebTech',
  tagline: 'Your Success, Our Innovation',
  description: 'Veerawebtech is the leading Web Designing Company In Dharmapuri, Tamil Nadu. We create awesome websites with the latest technologies.',
  contact: {
    email: 'info@veerawebtech.com',
    phone: '+91 8807571005',
    address: 'Dharmapuri, Tamil Nadu, India'
  },
  colors: {
    primary: '#6366f1',
    secondary: '#8b5cf6',
    accent: '#ec4899',
    dark: '#0f0f10'
  }
};

export const services = [
  {
    id: 1,
    title: 'Web Development',
    description: 'Creating stunning and responsive websites using the latest web technologies and 3D interactions.',
    icon: 'Code',
    features: ['Responsive Design', 'Modern Stack', 'SEO Optimized', 'Fast Loading'],
    image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&q=80'
  },
  {
    id: 2,
    title: 'Mobile Development',
    description: 'Developing high-performance native and cross-platform mobile applications for Android & iOS.',
    icon: 'Smartphone',
    features: ['Native Apps', 'Cross-Platform', 'User-Friendly UI', 'Scalable Architecture'],
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80'
  },
  {
    id: 3,
    title: 'Digital Marketing',
    description: 'Providing comprehensive digital marketing solutions to elevate your brand presence online.',
    icon: 'TrendingUp',
    features: ['SEO Services', 'Social Media Strategy', 'Content Marketing', 'Analytics & Insights'],
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80'
  }
];

export const products = [
  {
    id: 1,
    name: 'School Management ERP',
    description: 'Complete all-in-one management software for educational institutions and academies.',
    category: 'Education',
    features: ['Student Directory', 'Attendance Tracking', 'Fee Management', 'Report Card Generation']
  },
  {
    id: 2,
    name: 'Gym & Fitness Software',
    description: 'Comprehensive gym, fitness center, and membership management solution.',
    category: 'Fitness',
    features: ['Membership Plans', 'Workout Tracking', 'Automated Billing', 'Trainer Scheduling']
  },
  {
    id: 3,
    name: 'Billing & POS Software',
    description: 'Efficient GST-compliant billing and inventory management system for retail & services.',
    category: 'Business',
    features: ['Instant Invoicing', 'Inventory Control', 'GST Reports', 'Financial Analytics']
  }
];

export const freeOfferings = [
  {
    id: 1,
    title: 'Free Domain (1st Year)',
    description: 'We provide a free domain (.com / .in) of your choice for the first year with any website package.',
    icon: 'Globe'
  },
  {
    id: 2,
    title: 'Free Web Hosting (1st Year)',
    description: 'High-speed cloud server hosting with 99.9% uptime included free for your first year.',
    icon: 'Server'
  },
  {
    id: 3,
    title: 'Free SSL Certificate',
    description: 'Complete data security for your web visitors with an HTTPS SSL certificate included forever.',
    icon: 'Shield'
  }
];

export const reasonsToChoose = [
  { id: 1, title: 'Technical Expertise', description: 'Skilled engineers experienced in cutting-edge web technologies.' },
  { id: 2, title: 'Innovation First', description: 'Delivering modern, interactive, and unique digital experiences.' },
  { id: 3, title: 'Uncompromising Quality', description: 'Rigorous testing ensuring every pixel and line of code is polished.' },
  { id: 4, title: 'Customer-Centric', description: 'Dedicated support and close collaboration throughout development.' },
  { id: 5, title: '100% Mobile Responsive', description: 'Flawless layout adaptation across phones, tablets, and desktops.' },
  { id: 6, title: 'SEO Ready', description: 'Built from the ground up to rank higher on search engines.' },
  { id: 7, title: 'Full Transparency', description: 'Live preview links provided during active development.' },
  { id: 8, title: 'Agile & Flexible', description: 'Open to continuous feedback and adaptive to changing business needs.' }
];

export const portfolio = {
  web: [
    { id: 1, title: 'E-commerce Platform', category: 'Web', image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80' },
    { id: 2, title: 'Corporate Portal', category: 'Web', image: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=800&q=80' },
    { id: 3, title: '3D Landing Experience', category: 'Web', image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=800&q=80' },
    { id: 4, title: 'Tech Blog Platform', category: 'Web', image: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800&q=80' }
  ],
  mobile: [
    { id: 5, title: 'Fitness Tracker App', category: 'Mobile', image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80' },
    { id: 6, title: 'Food Express App', category: 'Mobile', image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80' },
    { id: 7, title: 'Social Connect', category: 'Mobile', image: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&q=80' },
    { id: 8, title: 'Learning Portal App', category: 'Mobile', image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80' }
  ]
};

export const manifesto = [
  { number: '01', title: 'Innovation First', description: 'We push boundaries and embrace cutting-edge technologies to deliver solutions that stand out.' },
  { number: '02', title: 'Quality Obsessed', description: 'Every line of code, every pixel matters. We craft digital experiences with meticulous attention to detail.' },
  { number: '03', title: 'Client Success', description: 'Your growth is our mission. We partner with you to turn your vision into reality and drive measurable results.' },
  { number: '04', title: 'Future Ready', description: 'We build scalable, maintainable solutions that evolve with your business and stand the test of time.' }
];

export const careersData = [
  {
    id: 1,
    role: 'Senior 3D Web Engineer',
    department: 'Engineering',
    type: 'Full-Time',
    location: 'Remote / Dharmapuri',
    description: 'Lead the development of interactive 3D WebGL user experiences using React, Three.js, and WebAssembly.',
    perks: ['Flexible Hours', 'Latest M-Series Hardware', 'Health Insurance']
  },
  {
    id: 2,
    role: 'Mobile App Specialist (React Native/Flutter)',
    department: 'Engineering',
    type: 'Full-Time',
    location: 'Hybrid',
    description: 'Build fast, beautiful cross-platform iOS & Android mobile applications for enterprise clients.',
    perks: ['Performance Bonus', 'Skill Allowance', 'Remote Option']
  },
  {
    id: 3,
    role: 'UI/UX & Product Designer',
    department: 'Design',
    type: 'Full-Time',
    location: 'Remote',
    description: 'Craft high-converting glassmorphism design systems, 3D product mockups, and micro-interactions.',
    perks: ['Figma Pro License', 'Design Workshops', 'Annual Retreat']
  }
];
